import _ from "lodash/fp";

export const parseError = errorResponse => {
  const handleMessage = message => {
    let wholeMessage = "";
    let errors = message;
    if (typeof errors === "string") {
      wholeMessage = errors;
    } else if (errors.constructor === Array) {
      for (let i = 0; i < errors.length; i++) {
        let error = errors[i];
        wholeMessage = `${wholeMessage}${
          error.message ? error.message : error
        }\n`;
      }
    } else if (errors.constructor === Object) {
      if (errors.message) {
        wholeMessage = `${wholeMessage}${errors.message}\n`;
      } else {
        for (var property in errors) {
          for (var i = 0; i < errors[property].length; i++) {
            let value = errors[property][i];
            wholeMessage = `${wholeMessage}${capitalizeFirstLetter(
              property
            )} ${value} \n`;
          }
        }
      }
    }
    return wholeMessage;
  };
  if (errorResponse.message) {
    return handleMessage(errorResponse.message);
  }
  if (errorResponse.full_messages) {
    return handleMessage(errorResponse.full_messages);
  }
  if (errorResponse.errors) {
    return handleMessage(errorResponse.errors);
  }
  if (errorResponse.error) {
    return handleMessage(errorResponse.error);
  }
  if (errorResponse.hasOwnProperty("state")) {
    return errorResponse.payment_request.message;
  }
  return "Unknown error";
};

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const handleErrorRequest = (error) => {
  if (error.statusText) {
    return error.data.errors[0];
  }
  if (error.response === undefined) {
    return  "Service timed out!"
  } else if(error.response === "inactiveAccount"){
    return "Your account is inactive!" 
  } else if (Object.keys(error.response.data).length === 0) {
    return error.toString();
  } else {
    return parseError(error.response.data);
  }
};

const flattenObjectFormData = object => {
  const encodedObject = {};
  const encode = (obj, name) => {
    Object.keys(obj).forEach(key => {
      if (
        obj[key] &&
        (obj[key].constructor === Object || obj[key].constructor === Array)
      ) {
        encode(obj[key], name ? `${name}[${key}]` : key);
      } else if (name) {
        encodedObject[`${name}[${key}]`] = obj[key];
      } else {
        encodedObject[key] = object[key];
      }
    });
  };
  encode(object);
  return encodedObject;
};

export const objectToFormData = _.pipe(
  flattenObjectFormData,
  object => {
    const data = new FormData();
    Object.keys(object).forEach(key => {
      data.append(key, object[key]);
    });
    return data;
  }
);
